export const check = async (): Promise<void> => {}

export const request = async (): Promise<void> => {}

export const requestAppTrackingTransparency = async () => {}

export const setIDFA = async () => {}
